import { Dropdown, Space } from "antd";
import React, { Component } from "react";
import ProposalBloc from "../../../bloc/proposal_bloc";
import QuotationBloc from "../../../bloc/quotation_bloc";
import Config from "../../../Config";
import "./app_dropdown_action.css";
import LanguageBloc from "../../../bloc/language_bloc";
import Labels from "../../constant/labels";
import App_notice_dialog from "../../dialog/app_notice_dialog/app_notice_dialog";
import ContactBloc from "../../../bloc/contact_bloc";

export default class DropDownContactAction extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mooduleConfig: {},
      isOpenDeleteDialog: false
    };
  }
  componentDidMount() {
    this.setState({
      moduleConfig: Config,
    });
  }

  stateConfig() {
    return this.state.moduleConfig;
  }

  stateItemId() {
    return this.props.id;
  }

  stateQuotationId() {
    return this.props.id;
  }

  stateQuotationIdByProposal() {
    return this.props.quotationId;
  }

  stateModule() {
    return this.props.module;
  }

  stateStatus() {
    return this.props.status;
  }

  getAssetsContextPath() {
    return "/myCUEPACSCare";
  }

  stateIsOpenDeleteDialog() {
    return this.state.isOpenDeleteDialog;
  }

  async onProceed() {
    let quotationId = this.stateQuotationId();
    this.setState({
      loading: true,
    });

    ProposalBloc.createNewProposal(quotationId)
      .then((result) => {
        if (result.success) {
          let proposalId = result.data[0].proposal.id;
          this.setState({
            proposalId,
            loading: false,
          });
          window.location.href = QuotationBloc.getProposalSubmissionUrl(
            proposalId,
            quotationId
          );
        }
      })
      .catch((e) => {
        ProposalBloc.getProposalByQuotationId(quotationId)
          .then((result) => {
            let proposalId = result;
            this.setState({
              loading: false,
            });
            window.location.href = QuotationBloc.getProposalSubmissionUrl(
              proposalId,
              quotationId
            );
          })
          .catch((error) => {
            this.setState({
              loading: false,
            });
          });
      });
  }

  async onDelete() {
    let id = this.stateItemId();
    this.setState({
      loading: true,
    });
    let payload = {
      "quotationIds": this.props.quotationIds || [],
      "proposalIds": this.props.proposalIds || []
    }
    ContactBloc.deleteContactById(id, payload).then((result) => {
      if (result.success) {
        this.setState({
          loading: false,
          isOpenDeleteDialog: false
        });
        if (this.props.refresh) {
          this.props.refresh();
        }
      }
    }).catch(e => {
      console.log("Api Error");
    })
  }

  getLabelsDeleteDialog() {
    return [
      "LBL_CONTACT_DELETE_DIALOG_TITLE",
      "LBL_CONTACT_DELETE_DIALOG_DESC",
      "LBL_CONTACT_DELETE_YES"
    ];
  }

  openDeleteDialog() {
    this.setState({
      isOpenDeleteDialog: true
    })
  }

  onCloseDeleteDialog() {
    this.setState({
      isOpenDeleteDialog: false
    })
  }

  onActionButtonDialog(e) {
    if (e == "yes") {
      this.onDelete();
    } else {
      this.onCloseDeleteDialog();
    }
  }

  async createNewQuotation() {
    let clientId = this.stateItemId()
    let payload = {
      clientId: clientId
    }
    let result = await QuotationBloc.createNewQuotation(payload);
    window.location.href = `/${Config.context}/${Config.routes.generic.quotation_personal_details}/${result}/${clientId}`;
  }

  getActions() {
    let allowedToDelete = this.props.allowedToDelete || false
    let labels = Config[this.stateModule()].actions[this.stateStatus()].labels;
    let links = Config[this.stateModule()].actions[this.stateStatus()].urls;
    let items = [];

    labels = labels.filter(function (item) {
      return item !== (allowedToDelete == false ? "Delete" : "")
    })

    links = links.filter(function (item) {
      return item !== (allowedToDelete == false ? "/" : "")
    })

    labels.forEach((item, idx) => {
      let record = {};
      record = {
        label: (
          <>
            <div
              onClick={(e) => {
                e.stopPropagation();  
                if (item == "Delete") {
                  this.openDeleteDialog();
                } else if (item == "Generate Quotation") {
                  this.createNewQuotation()
                } else if (item == "View Transactions") {
                  window.location.href = `/${Config.context}/${"contact/view/transactions"
                    }/${this.stateItemId()}`;
                } else {
                  window.location.href = `/${Config.context}/${links[idx]
                    }/${this.stateItemId()}`;
                }
              }}
              className={`dropdown-action-item 
              ${idx == 0 ? `dropdown-action-first-item` : null}
                ${idx == labels.length - 1 ? `dropdown-action-last-item` : null}
              `}
              style={{ width: 250 }}
            >
              {item}
            </div>
          </>
        ),
        key: idx,
      };

      items.push(record);
      if (idx != labels.length - 1) {
        items.push({
          type: "divider",
        });
      }
    });
    return { items };
  }

  render() {
    return (
      <>
        <App_notice_dialog
          isOpen={this.stateIsOpenDeleteDialog()}
          title={LanguageBloc.getTextByCode(Labels[this.getLabelsDeleteDialog()[0]])}
          subTitle={
            LanguageBloc.getTextByCode(Labels[this.getLabelsDeleteDialog()[1]])
          }
          negativeButton={LanguageBloc.getTextByCode(Labels.LBL_DELETE_NO)}
          positiveButton={LanguageBloc.getTextByCode(this.getLabelsDeleteDialog()[2])}
          onCloseDialog={(e) => {
            this.onActionButtonDialog(e);
          }}
        />
          <Dropdown menu={this.getActions()} trigger={ 
            ["click"]
            }>
          <a onClick={(e) => e.stopPropagation()}>
            <Space>
              <img
                src={
                  this.getAssetsContextPath() + `/assets/icons/horizontalThreeDots.svg`
                }
                alt="View More"
              />
            </Space>
          </a>
        </Dropdown>
       {/* <div class="dropdown" style={{zIndex:"1095"}}>
          <div            
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"            
          >
            <div>
              <img
                src={
                  this.getAssetsContextPath() + `/assets/icons/horizontalThreeDots.svg`
                }
                alt="View More"
              />
            </div>
          </div>
          <div class="dropdown-menu" aria-labelledby="">
            <a class="dropdown-item" onClick={(e) => {

            }}>
              OKKKKKK1
            </a>
            <a class="dropdown-item" onClick={(e) => {

            }}>
              OKKKKKK1
            </a>
            <a class="dropdown-item" onClick={(e) => {

}}>
  OKKKKKK1
</a>
<a class="dropdown-item" onClick={(e) => {

}}>
  OKKKKKK1
</a>
<a class="dropdown-item" onClick={(e) => {

}}>
  OKKKKKK1
</a>
            
          </div>
        </div> */}
        
      </>
    );
  }
}
